export default __webpack_public_path__ + "static/media/ai.dc441046.jpg";